import { render, staticRenderFns } from "./CmdsInkas.vue?vue&type=template&id=cf89889e&scoped=true&"
import script from "./CmdsInkas.vue?vue&type=script&lang=js&"
export * from "./CmdsInkas.vue?vue&type=script&lang=js&"
import style0 from "./CmdsInkas.vue?vue&type=style&index=0&id=cf89889e&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf89889e",
  null
  
)

export default component.exports